import React from 'react';

import styles from './ArrayContainer.module.css';
import Tooltip from '@material-ui/core/Tooltip';

const ArrayContainer = ({
    children,
    header,
    remove,
    isProtected = false,
    isProtectedMessage = '',
    topSpace = true
}) => {
    const containerClasses = [styles.arrayContainer];
    if (topSpace) {
        containerClasses.push(styles.marginTop);
    } else {
        containerClasses.push(styles.marginTopSmall);
    }
    return (
        <div className={containerClasses.join(' ')}>
            <div className={styles.header}>{header}</div>
            <div className={styles.content}>{children}</div>
            {remove &&
                (isProtected ? (
                    <Tooltip
                        className={styles.tabTooltip}
                        title={isProtectedMessage}
                        enterDelay={100}
                        classes={{ tooltip: 'moreInfoIcon-tooltip' }}
                        placement="bottom">
                        <button disabled className={styles.remove} onClick={() => {}}></button>
                    </Tooltip>
                ) : (
                    <button className={styles.remove} onClick={remove}></button>
                ))}
        </div>
    );
};

export default React.memo(ArrayContainer);
